import { axiosInstance } from "../utils/ApiClient";

export const priorityDashboardService = {
  getAccounts: async (params = {}) => {
    try {
      const response = await axiosInstance.get("/priority-dashboard/", {
        params,
      });
      return response.data;
    } catch (error) {
      console.error("Error fetching priority accounts:", error);
      throw error;
    }
  },

  getSummary: async () => {
    try {
      const response = await axiosInstance.get("/priority-dashboard/summary/");
      return response.data;
    } catch (error) {
      console.error("Error fetching priority dashboard summary:", error);
      throw error;
    }
  },
};
